export default () => {
  const data = {
    event_name: 'click',
    button_name: 'open_photo',
    page_section: 'photos_section',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
